<template>
  <div class="pageNotFound max-space-flex">
    <p class="aliceblue large fira">Error 404: Page Not Found</p>
  </div>
</template>

<script lang="ts" setup>
</script>

<style scoped>
.pageNotFound {
  align-items: center;
  justify-content: center;
}
</style>